import React from 'react';
import { cn } from '../../lib/utils';

export interface AppBrandIconProps {
  className?: string;
  iconClassName?: string;
}

/** Workspace grid mark — modules, panels, and unified hub (replaces envelope-only branding). */
export const AppBrandIcon: React.FC<AppBrandIconProps> = ({ className, iconClassName }) => (
  <div
    className={cn(
      'flex items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 via-violet-600 to-purple-700 shadow-lg shadow-indigo-500/30',
      className,
    )}
  >
    <svg
      className={cn('text-white', iconClassName)}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M4.5 4.5h6v6h-6v-6z M13.5 4.5h6v6h-6v-6z M4.5 13.5h6v6h-6v-6z M13.5 13.5h6v6h-6v-6z"
      />
    </svg>
  </div>
);

export default AppBrandIcon;
